/**
 * Copyright © 2026 Adnuntius AS.
 *
 * List-page chrome (shell, sort header, pagination, search, undo, new-item action).
 * Feature-local so AppSharedModule stays pipes/banners only.
 */
import {NgModule} from '@angular/core';
import {FormsModule} from '@angular/forms';
import {TranslateModule} from '@ngx-translate/core';
import {ButtonsModule} from 'ngx-bootstrap/buttons';

import {AppSharedModule} from '../app-shared.module';
import {AdminResourceListShellComponent} from './admin-resource-list-shell.component';
import {ListCountBadgeComponent} from './list-count-badge.component';
import {ListDefaultActionsComponent} from './list-default-actions.component';
import {UndoDeleteComponent} from './html/undo-delete-component';
import {AdnSortingHeaderComponent} from './html/sorting-header.component';
import {AdnPaginationComponent} from './pagination/pagination.component';
import {SearchPaginationComponent} from './pagination/search-pagination.component';
import {SearchListComponent} from './search-list.component';

const ADMIN_LIST = [
  AdminResourceListShellComponent,
  ListDefaultActionsComponent,
  ListCountBadgeComponent,
  AdnPaginationComponent,
  SearchPaginationComponent,
  SearchListComponent,
  UndoDeleteComponent,
  AdnSortingHeaderComponent
];

@NgModule({
  imports: [
    AppSharedModule,
    FormsModule,
    TranslateModule,
    ButtonsModule
  ],
  declarations: ADMIN_LIST,
  exports: ADMIN_LIST
})
export class AdminListModule {
}
